export default __webpack_public_path__ + "static/media/Mark-5-HUD-3D (Environmental Scan).89e06373.jpg";